import { TAppNotificationParams } from '@src/providers/App/models';

export const SUCCESS_STATUS = [200, 201];

export const DEFAULT_ERROR_MESSAGE: TAppNotificationParams = {
  view: 'error',
  content: 'Во время запроса произошла ошибка',
  title: 'Внимание!',
};
